Alerts = require 'app/scripts/views/lib/alerts'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
$ = require 'jquery'
addToTeamTemplate = require 'app/scripts/views/templates/popover_add_to_team'
l = require 'app/scripts/lib/localize'
localizeServerError = require 'app/scripts/lib/localize-server-error'
{ maybeDisplayOrgMemberLimitsError } = require 'app/scripts/views/organization/member-limits-error'

module.exports = class AddToTeamPopoverView extends View
  viewTitleKey: 'add to team'

  events:
    'click .js-add-to-team': 'addToTeam'

  render: ->
    teamType = l(['products', if @options.isBC then 'bc' else 'enterprise'])

    @$el.html(addToTeamTemplate({ teamType }))
    @

  showError: (message) ->
    errorMessage = localizeServerError(message)
    Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  addToTeam: (e) ->
    Util.preventDefault(e)

    @$('.js-add-to-team').attr('disabled', true).addClass('disabled')

    if maybeDisplayOrgMemberLimitsError($(e.target), @options.org, @model)
       return

    if !@options.isOrgView  # this popover is also used where team errors aren't shown
      @options.org.addMember(@model).then =>
        if @options.showAlert ?= false
          Alerts.show('added to team', 'confirm', 'info', 3000)

      .catch (err) =>
        @showError(err.message)
      .finally =>
        PopOver.hide()
    else
      @options.org.addMembers(@model)
      .then (statusMessages) =>
        successResponse = statusMessages[statusMessages._categories.ADDED]

        if successResponse && @options.showAlert ?= false
          Alerts.show('added to team', 'confirm', 'info', 3000)

        PopOver.hide()
